import React, { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import { GlobalBannerProvider } from 'hooks/globalBanner';
import { HOME_ROUTES, IMPORT_ROUTES, TEMPLATE_ROUTES } from 'constants';
import { MAP_MANAGER_ROUTES } from 'constants';
import useRegisterPendoMetadata from 'hooks/useRegisterPendoMetadata';
import { useLoginUser } from 'hooks/loginUserContext';
const HomePage = lazy(() => import('pages/Home/Home'));
const NotFound = lazy(() => import('pages/NotFound/NotFound'));

/** When using nested routes, it is important that the parent path is not marked 'exact' */
const RootRoutes = () => {
	const {
		Home,
		Templates,
		Aliases,
		CustomMaps,
		Registrations,
		Analytics,
		Migrations,
		Configs,
		Export,
		Import
	} = HOME_ROUTES;
	const loginUser = useLoginUser();
	useRegisterPendoMetadata(Boolean(loginUser.user), process.env.NODE_ENV);
	return (
		<GlobalBannerProvider>
			<Switch>
				<Route exact path={Home} component={HomePage} />
				<Route
					exact
					path={[
						Import,
						IMPORT_ROUTES.Upload,
						IMPORT_ROUTES.SelectMap,
						IMPORT_ROUTES.CreateMap,
						IMPORT_ROUTES.EditMap,
						IMPORT_ROUTES.Validate,
						IMPORT_ROUTES.Process,
						Templates,
						TEMPLATE_ROUTES.Upload,
						TEMPLATE_ROUTES.MultiSheetUpload,
						Aliases,
						Analytics,
						CustomMaps,
						Migrations,
						MAP_MANAGER_ROUTES.SelectMap,
						MAP_MANAGER_ROUTES.CreateMap,
						MAP_MANAGER_ROUTES.EditMap,
						Registrations
						// Configs,
						// Export
					]}
					component={HomePage}
				/>

				<Route path={'*'} component={NotFound} />
			</Switch>
		</GlobalBannerProvider>
	);
};

export default RootRoutes;
